import Cookies from 'js-cookie'

const TokenKey = 'X-Token'
const UserKey = 'User-Info'
export function getToken() {
    return Cookies.get(TokenKey) ? Cookies.get(TokenKey) : ''
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getUser() {
    return Cookies.get(UserKey) ? JSON.parse(Cookies.get(UserKey)) : ''
}

export function setUser(user) {
    return Cookies.set(UserKey, JSON.stringify(user))
}

export function removeUser() {
    return Cookies.remove(UserKey)
}

